import React, { useEffect, useState } from "react";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "./style.scss";
import "../../../../style/buttons.scss";
import "../../../../style/hovers.scss";
import "../../../../index.scss";
import { Exercise } from "../../../models/Exercise";
import { format } from "date-fns";
import { TbCalendarStats, TbTicket } from "react-icons/tb";
import { BsClock, BsPeople } from "react-icons/bs";
import { AiOutlineUserAdd } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import useExerciseInfo from "./useExerciseInfo";
import ExerciseInfoPassSelector from "./ExerciseInfoPassSelector";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useFacility from "../../../../utils/hooks/useFacility";
import ExerciseInfoPassSelectorReservationList from "./ExerciseInfoPassSelectorReservationList";
import HtmlTooltip from "@mui/material/Tooltip";
import EAButton from "../../shared/Buttons/EAButton";
import CoachInfo from "./CoachInfo";
import { MdOutlineBackspace } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import EAAlert from "../../shared/EAAlert";
import { LOGIN_PAGE } from "../../../routes";
import { useNavigate } from "react-router";
import EAArticle from "../../shared/EAArticle/EAArticle";

interface IProps {
  exercise: Exercise;
  handleModals: (value: string) => void;
  joinToExercise: (value: boolean, passId: string) => void;
  leaveFromExercise?: () => void;
  joinErrorData?: { exerciseIds: string; passIds: string } | null;
  alerts: string;
  assignedStatus: boolean;
  waitList: boolean;
  ticketsListLength: number;
  showLoginButton?: boolean;
}

const ExerciseInfo: React.FC<IProps> = ({
  handleModals,
  exercise,
  joinToExercise,
  alerts,
  assignedStatus,
  waitList,
  ticketsListLength,
  leaveFromExercise,
  joinErrorData,
  showLoginButton = false,
}) => {
  const { currentTimev2, loading, availablePasses } = useExerciseInfo();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );
  const calendar_AllowSingleTickets = useSelector(
    (state: State) => state.config.configuration.calendar_AllowSingleTickets
  );
  const facilityIds = useFacility();
  const [reservedList, setReservedList] = useState(true);

  useEffect(() => {
    if (facilityIds === "1212") {
      if (exercise.capacity - (exercise.reserved + exercise.prereservation) < 0) {
        setReservedList(false);
      }
    }
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="exercise-info">
        <div className="content">
          <div className="exercise-info-dates">
            <div className="flex-start-center ">
              <TbCalendarStats className="icon-details" />

              <b> {format(exercise.startTime, "dd.MM.yyyy")}</b>
            </div>
            <div className="flex-start-center">
              <BsClock className="icon-details" />

              <b>{format(exercise.startTime, "HH:mm")}</b>
            </div>





            <div className="flex-start-center">
              <BsPeople className="icon-details" />
              <b>
                {exercise.reserved + exercise.prereservation}/{exercise.capacity}
              </b>

            </div>







            {exercise.zone.displayName && (
              <div className="flex-start-center">
                <IoLocationOutline className="icon-details" />
                <b>
                  {t("strefa")}: {exercise.zone.displayName}
                </b>
              </div>
            )}



          </div>

          {/* 

              <EAChip label={t("lista_rezerwowa")} variant="warning" />
 */}




            <div className="execise_asign_status">    
          {assignedStatus && waitList === false && <EAAlert type="success" variant="chip" message={t("jestes_zapisany")} />}

          <HtmlTooltip
            placement="bottom-start"
            title={
              <>
                <article
                  className="tooltip-description"
                  dangerouslySetInnerHTML={{
                    __html:
                      "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
                  }}
                ></article>
              </>
            }
          >
            <div>
              {waitList === true && (
                <EAAlert type="warning" variant="chip" message={`${t("lista_rezerwowa")} (${exercise.waitListPosition})`}/>
              )}
            </div>
          </HtmlTooltip>
</div>





          <EAArticle content={exercise.description} maxHeight="320px" showScrollHint={true} />

          <CoachInfo
            humanName={exercise.humanName}
            humanPicture={exercise.humanPicture}
            deputyHumanIds={exercise.deputyHumanIds}
            deputyHumanName={exercise.deputyHumanName}
          />

          {alerts.length > 1 && (
            <EAAlert
              message={alerts}
              type="error"
              buttonText={showLoginButton ? "Zaloguj się" : ""}
              onButtonClick={() => navigate(`${LOGIN_PAGE}?redirect=previousPath`)}
            />
          )}

          {joinErrorData && leaveFromExercise && (
            <EAButton
              title="Wypisz się z tych zajęć"
              startIcon={<MdOutlineBackspace />}
              onClick={leaveFromExercise}
              fullWidth
              color="error"
            />
          )}

          {currentTimev2 > exercise.saleFrom && currentTimev2 < exercise.saleTo && (
            <>
              <div className="flex-between-center buttons">
                {calendar_AllowSingleTickets && ticketsListLength > 0 && (
                  <EAButton
                    title={t("kup_jednorazowy_bilet")}
                    onClick={() => handleModals("ticketsModal")}
                    endIcon={<TbTicket />}
                  />
                )}
                {allowReservationByPassOnFitnessPlan && (
                  <>
                    {assignedStatus ? (
                      <EAButton
                        title={t("zrezygnuj")}
                        onClick={() => joinToExercise(true, "null")}
                        endIcon={<AiOutlineUserAdd />}
                        color="secondary"
                      />
                    ) : (
                      <>
                        {reservedList ? (
                          <ExerciseInfoPassSelector
                            exerciseStart={exercise.startTime}
                            reservationList={reservedList}
                            loading={loading}
                            passesList={availablePasses}
                            joinToExercise={joinToExercise}
                          />
                        ) : (
                          <ExerciseInfoPassSelectorReservationList
                            exerciseStart={exercise.startTime}
                            reservationList={reservedList}
                            loading={loading}
                            passesList={availablePasses}
                            joinToExercise={joinToExercise}
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ExerciseInfo;
